// Follows "HR Design rules.md": GEN, DIS
import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

import { cn } from '@/lib/utils';

/**
 * Field label: 14px, weight 500, sentence case (CPY-02). The label of a disabled field turns
 * `disabled-foreground` (DIS-03), never faded. It stays inline (not the design system's flex row) so a
 * trailing `<OptionalMark />` keeps its leading space.
 */
function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'select-none text-sm font-medium leading-none',
        'peer-disabled:cursor-not-allowed peer-disabled:text-disabled-foreground',
        'group-data-[disabled=true]:cursor-not-allowed group-data-[disabled=true]:text-disabled-foreground',
        'data-[disabled=true]:text-disabled-foreground [&:has(+:disabled)]:text-disabled-foreground',
        className
      )}
      {...props}
    />
  );
}
Label.displayName = 'Label';

export { Label };
